import { render, staticRenderFns } from "./OpinionAudio.vue?vue&type=template&id=0eb721b0&"
import script from "./OpinionAudio.vue?vue&type=script&lang=ts&"
export * from "./OpinionAudio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports